<template>
  <md-card class="transfer-confirm">
    <md-progress-bar
      v-if="isPending"
      md-mode="indeterminate"
    />

    <md-card-header>
      <div class="md-title">{{ i18n.topup_confirm() }}</div>
    </md-card-header>

    <md-card-content>
      <div class="transfer-confirm__inner">
        <detail-row
          :prop="i18n.lbl_asset()"
          :value="`${opts.destAsset}`"
        />
        <detail-row
          :prop="i18n.lbl_amount()"
          :value="`${i18n.c(opts.amount)} ${opts.destAsset}`"
        />
        <detail-row
          v-if="opts.externalDetails.address"
          :prop="i18n.topup_external({ asset: opts.destAsset })"
          :value="`${opts.externalDetails.address}`"
        />
        <div v-else class="withdrawal-cashbox__row">
          <p>{{ i18n.topup_cashbox() }}</p>
        </div>
        <div class="md-size-100">
          <h4><b>{{ i18n.lbl_sender_fees() }}</b></h4>
          <detail-row
            :prop="i18n.lbl_fixed()"
            :value="`${i18n.c(opts.fee.fixed)} ${opts.destAsset}`"
          />
          <detail-row
            :prop="i18n.lbl_percent()"
            :value="`${i18n.c(opts.fee.percent)} ${opts.destAsset}`"
          />
        </div>
        <div
          v-if="currentAssetLimit()"
          class="md-size-100"
        >
          <h4><b>{{ i18n.lbl_limits() }}</b></h4>
          <div
            v-if="currentAssetLimit() && currentAssetLimit().dailyLimit"
            class="withdrawal-daily-limit"
          >
            <p>{{i18n.lim_withdrawal_daily_msg1({asset: opts.destAsset, limit: currentAssetLimit().dailyLimit})}}</p>
            <div v-if="opts.externalDetails.address && opts.destAsset === 'UAH'">
              <p>{{i18n.lim_withdrawal_daily_msg2({asset: opts.destAsset, limit: 14900})}}</p>
            </div>
            <div v-else>
              <p>{{i18n.lim_withdrawal_daily_msg2({asset: opts.destAsset, limit: currentAssetLimit().dailyLimit})}}</p>
            </div>
            <p>{{i18n.lim_withdrawal_daily_msg3()}}</p>
          </div>
          <br/>
          <detail-row
            v-if="currentAssetLimit() && currentAssetLimit().dailyLimit"
            :prop="i18n.lim_daily_left()" :value="`${currentAssetLimit().dailyLeft} ${opts.destAsset}`"
          />
          <detail-row
            v-if="currentAssetLimit() && currentAssetLimit().weeklyLimit"
            :prop="i18n.lim_weekly_left()" :value="`${currentAssetLimit().weeklyLeft} ${opts.destAsset}`"
          />
          <detail-row
            v-if="currentAssetLimit() && currentAssetLimit().monthlyLimit"
            :prop="i18n.lim_monthly_left()" :value="`${currentAssetLimit().monthlyLeft} ${opts.destAsset}`"
          />
          <detail-row
            v-if="currentAssetLimit() && currentAssetLimit().annualLimit"
            :prop="i18n.lim_annual_left()" :value="`${currentAssetLimit().annualLeft} ${opts.destAsset}`"
          />
        </div>
      </div>
    </md-card-content>
    <md-dialog-actions class="withdrawal-dialog__actions">
      <md-button
        class="md-primary"
        @click="$emit(commonEvents.cancelClickEvent)"
        :disabled="isPending"
      >
        {{ i18n.lbl_cancel() }}
      </md-button>
      <md-button
        class="md-primary"
        @click="$emit(commonEvents.confirmClickEvent, form.sourcePaysForDest)"
        :disabled="isPending"
      >
        {{ i18n.lbl_confirm() }}
      </md-button>
    </md-dialog-actions>
  </md-card>
</template>

<script>
import DetailRow from '@vue/app/common/Detail.Row'
import TextareaField from '@com/fields/TextareaField'

import { mapGetters, mapActions } from 'vuex'
import { vuexTypes } from '@vuex/types'
import { commonEvents } from '@js/events/common_events'
import { formatDate } from '@utils/dates.util'
import { assetMap } from '@const'
import { i18n } from '@js/i18n'
import { add } from '@utils/math.util'

export default {
  name: 'TopupBalance-confirm',
  components: { DetailRow, TextareaField },
  props: { opts: { type: Object, required: true }, isPending: { type: Boolean, default: false } },
  data: _ => ({
    i18n,
    assetMap,
    commonEvents,
    form: {
      sourcePaysForDest: false
    }
  }),
  computed: {
    ...mapGetters([
      vuexTypes.accountLimits
    ]),
    senderFee () {
      if (this.form.sourcePaysForDest) {
        return {
          fixed: add(this.opts.sourceFixedFee, this.opts.destinationFixedFee),
          percent: add(this.opts.sourcePercentFee, this.opts.destinationPercentFee)
        }
      }
      return {
        fixed: this.opts.sourceFixedFee,
        percent: this.opts.sourcePercentFee
      }
    },
    recipientFee () {
      if (this.form.sourcePaysForDest) {
        return { fixed: 0, percent: 0 }
      }
      return {
        fixed: this.opts.destinationFixedFee,
        percent: this.opts.destinationPercentFee
      }
    }
  },
  async created () {
    await this.loadLimits()
  },
  methods: {
    ...mapActions({
      loadLimits: vuexTypes.GET_ACCOUNT_LIMITS
    }),
    formatDate,
    currentAssetLimit () {
      return this.accountLimits.find(limit => limit.tokenCode === this.opts.destAsset)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~scss/variables';

  .transfer-confirm__subject-field {
    padding-top: 0;
  }

  .transfer-confirm__inner {
    padding: .75rem 1.2rem 0;
  }

  .withdrawal-cashbox__row,
  .withdrawal-daily-limit {
    color: rgba($grey, .5);
  }
</style>



// WEBPACK FOOTER //
// src/vue/app/topupBalance/make/TopupBalance.Confirm.vue